import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Carousel,
  CarouselItem,
  CarouselControl
} from 'reactstrap'

const CarouselImg = ({ imagesURL }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    // DOWNLOAD IMAGES ON COMPONENT MOUNT TO CACHE
    imagesURL.forEach((q) => {
      const img = new Image()
      img.src = q
    })
  }, [])

  const next = () => {
    if (animating) return
    const nextIndex = activeIndex === imagesURL.length - 1 ? 0 : activeIndex + 1
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating) return
    const nextIndex = activeIndex === 0 ? imagesURL.length - 1 : activeIndex - 1
    setActiveIndex(nextIndex)
  }

  const goToIndex = (newIndex) => {
    if (animating) return
    setActiveIndex(newIndex)
  }

  const slides = imagesURL.map((url, i) => (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={i}>
      <div className='carousel-img' style={{ backgroundImage: `url("${url.src}")` }} />
    </CarouselItem>
  ))

  return (
    <Carousel
      ride='carousel'
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      {slides}
      <CarouselControl direction='prev' directionText='Previous' onClickHandler={previous} />
      <CarouselControl direction='next' directionText='Next' onClickHandler={next} />
    </Carousel>
  )
}

const LandingHeroCarousel = ({ heroSection, history, showButtons }) => (
  <>
    <CarouselImg imagesURL={heroSection.imagesURL} />
    <div className='hero-carousel row align-items-center px-0 px-md-5'>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 p-0 p-lg-5'>
        <div className='hero-content col-12 col-lg-7 col-xl-6 col-xxl-5 align-items-center pb-0'>
          <div className='px-3 px-lg-0'>
            <h1 className='hero-title'>{heroSection.title}</h1>
            <p className='hero-description'>{heroSection.description}</p>
            <div className='text-left pb-4'>
              {showButtons &&
                <div>
                  <button className='btn btn-primary mb-3 me-4' data-cy='hero-prescreen' onClick={() => history.push({ pathname: '/prescreening' })}>{heroSection.btn1_text}</button>
                  <button className='btn btn-outline-primary mb-3' data-cy='hero-required-docs' onClick={() => history.push({ pathname: '/required-documents' })}>{heroSection.btn2_text}</button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </ >
)

LandingHeroCarousel.propTypes = {
  heroSection: PropTypes.object,
  history: PropTypes.object,
  showButtons: PropTypes.bool
}

export default LandingHeroCarousel
